// import axios from "axios";
// import { getLocalStorageItem, removeLocalStorageItem } from "../../components/global/storage";

// const TOKEN_KEY = "limitless-jwt";

// // Tilpass: hvor skal brukeren når token er invalid?
// function redirectToLogin() {
//   // hvis dere har react-router: window.location.href = "/login";
//   window.location.href = "/login"; // evt /login
// }

// export const api = axios.create({
//   timeout: 15000, // hindrer evig heng ved dårlig nett
// });

// // Legg på token på alle requests
// api.interceptors.request.use((config) => {
//   const token = getLocalStorageItem(TOKEN_KEY);
//   config.headers = {
//     ...(config.headers || {}),
//     "Content-Type": config.headers?.["Content-Type"] || "application/json",
//     ...(token ? { Authorization: `Bearer ${token}` } : {}),
//   };
//   return config;
// });

// // Global håndtering av errors, spesielt 401
// api.interceptors.response.use(
//   (res) => res,
//   (error) => {
//     const status = error?.response?.status;

//     if (status === 401) {
//       // token utløpt / ugyldig -> rydd og send til login
//       removeLocalStorageItem(TOKEN_KEY);
//       redirectToLogin();
//     }

//     // VIKTIG: ikke swallow — la kallende kode få error så spinner stopper
//     return Promise.reject(error);
//   }
// );


import axios from "axios";
import * as Sentry from "@sentry/react";
import { getLocalStorageItem, removeLocalStorageItem } from "../../components/global/storage";

const TOKEN_KEY = "limitless-jwt";

function redirectToLogin() {
  window.location.href = "/login";
}

export const api = axios.create({
  timeout: 15000,
});

// Legg på token på alle requests
api.interceptors.request.use((config) => {
  const token = getLocalStorageItem(TOKEN_KEY);
  config.headers = {
    ...(config.headers || {}),
    "Content-Type": config.headers?.["Content-Type"] || "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return config;
});

// Global håndtering av errors
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url;
    const method = error?.config?.method?.toUpperCase();

    if (status === 401) {
      // 401 er forventet (utløpt token) — ikke send til Sentry
      removeLocalStorageItem(TOKEN_KEY);
      removeLocalStorageItem("limitless-user");
      redirectToLogin();
      return Promise.reject(error);
    }

    // Alt annet vil vi vite om
    Sentry.withScope((scope) => {
      scope.setTag("api_url", url);
      scope.setTag("http_status", status);
      scope.setTag("http_method", method);
      scope.setContext("request", {
        url,
        method,
        status,
        responseData: error?.response?.data,
      });
      Sentry.captureException(error);
    });

    return Promise.reject(error);
  }
);